import JWTDecode from "jwt-decode";
import GeckoFeatures from "../gecko-features";

export const GeckoEngage = ({getAuthTokenCallback}) => {

    const keys = ['engage', 'form'];

    let appKey;
    let decodedToken;
    const decodeToken = async () => {
        if (decodedToken) {
            return decodedToken;
        }

        const authToken = await getAuthTokenCallback();

        decodedToken = JWTDecode(authToken);
        return decodedToken
    }

    const hasEngageProperty = async () => {
        const decodedToken = await decodeToken();
        keys.every(key => {
            if (decodedToken?.apps?.hasOwnProperty(key)) {
                appKey = key;
                return false;
            }
            return true;
        });
        return appKey ? !!decodedToken?.apps[appKey]: false;
    }

    const fetchData = async (endpoint, method = 'GET', body = null) => {
        if (!GeckoFeatures.can('engage-contact-events')) {
            throw new Error('Events support is not enabled');
        }

        if (await hasEngageProperty() === false) {
            throw new Error('Engage property does not exist in JWT');
        }

        const headers = {
            'Authorization': `Bearer ${await getAuthTokenCallback()}`
        };

        const options = {
            method,
            headers
        };

        if (body) {
            options.body = JSON.stringify(body);
        }

        const url = (await decodeToken()).apps[appKey].api

        const response = await fetch(`${url}/${endpoint}`, options);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    }

    return {
        fetchData
    }
}